import {
  GET_ALL_EMPLOYEES,
  GET_EMPLOYEE,
  GET_ALL_EMP_ASSIGN_SUBJECTS,
  GET_EMP_ASSIGN_SUBJECTS,
  GET_EMPLOYEE_LEAVES,
  GET_SCHOOL_EMPLOYEES,
  UPDATE_EMPLOYEE_ID,
  UPDATE_COURSE_ID,
} from 'actions/admin/employees';

const initialState = {
  employeesData: {
    content: [],
  },
  employeeList: [],
  employee: {},
  empAssignSubjectList: [],
  empAssignSubject: [],
  employeeLeaveList: [],
  storeEmployeeId: null,
  storeCourseId: null,
};

export default function employees(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_EMPLOYEES:
      return { ...state, employeesData: action.employeesData };
    case GET_EMPLOYEE:
      return { ...state, employee: action.employee };
    case GET_ALL_EMP_ASSIGN_SUBJECTS: {
      return { ...state, empAssignSubjectList: action.empAssignSubjects };
    }
    case GET_EMP_ASSIGN_SUBJECTS: {
      return { ...state, empAssignSubject: action.empAssignSubject };
    }
    case GET_EMPLOYEE_LEAVES: {
      return { ...state, employeeLeaveList: action.empLeaves };
    }
    case GET_SCHOOL_EMPLOYEES: {
      return { ...state, employeeList: action.employees };
    }
    case UPDATE_EMPLOYEE_ID: {
      return { ...state, storeEmployeeId: action.employeeId };
    }
    case UPDATE_COURSE_ID: {
      return { ...state, storeCourseId: action.courseId };
    }
    default:
      return state;
  }
}
